import { gql } from "@apollo/client"

export const GET_EMPLOYEES = gql`
  query GetEmployees {
    getEmployees {
      id
      note
      ContactInfo {
        id
        note
        DateOfBirth
        Email
        Fax
        FaxType
        FirstName
        LastName
        MiddleName
        Phone1
        Phone1Type
        Phone2
        Phone2Type
        Phone3
        Phone3Type
        Title
        WebSite
      }
      EmployeeID
      EmployeeName
      LastModifiedDateTime
      Status
      _links {
        self
        files_put
      }
    }
  }
`
